module.exports = __webpack_public_path__ + "static/media/hBd6EPoQT2C8VQYv65ys_White_Sands.403fd324.jpg";